module.exports = (__webpack_require__(5849))("./node_modules/@studyportals/search-filters/dist/search_filters.js");